import { useEffect, useState } from "react";
import { useAuth } from "../lib/auth";
import { api } from "../lib/api";
import { Button } from "../components/ui/button";
import { Input } from "../components/ui/input";
import { Textarea } from "../components/ui/textarea";
import { Label } from "../components/ui/label";
import { toast } from "sonner";

const Profile = () => {
  const { user, refresh } = useAuth();
  const [form, setForm] = useState({
    name: user?.name || "",
    bio: user?.bio || "",
    instagram_handle: user?.instagram_handle || "",
    is_owner: user?.is_owner || false,
    is_influencer: user?.is_influencer || false,
  });
  const [requestingOwner, setRequestingOwner] = useState(false);

  useEffect(() => {
    if (!user) return;
    setForm({
      name: user.name || "",
      bio: user.bio || "",
      instagram_handle: user.instagram_handle || "",
      is_owner: user.is_owner || false,
      is_influencer: user.is_influencer || false,
    });
  }, [user]);

  const submit = async (e) => {
    e.preventDefault();
    try {
      const { is_owner, ...profilePayload } = form;
      await api.patch("/auth/profile", profilePayload);
      await refresh();
      toast.success("Profil diupdate");
    } catch { toast.error("Gagal update"); }
  };

  const requestOwnerAccess = async () => {
    setRequestingOwner(true);
    try {
      const res = await api.post("/auth/request-owner");
      await refresh();
      if (res.data.status === "already_owner") {
        toast.success("Akses restoran sudah aktif");
      } else {
        toast.success("Request akses restoran sudah dikirim ke admin");
      }
    } catch (e) {
      toast.error(e.response?.data?.detail || "Gagal mengirim request");
    } finally {
      setRequestingOwner(false);
    }
  };

  if (!user) return null;
  const ownerPending = user.owner_request_status === "pending";

  return (
    <div data-testid="profile-page">
      <h1 className="font-heading text-3xl font-black mb-6">Profil Saya</h1>
      <form onSubmit={submit} className="warm-card p-6 space-y-4 max-w-2xl">
        <div className="flex items-center gap-4 pb-4 border-b border-border">
          <img src={user.picture} alt="" className="w-20 h-20 rounded-full object-cover" />
          <div>
            <div className="font-bold">{user.email}</div>
            <div className="text-xs text-muted-foreground">Login Kulintara</div>
          </div>
        </div>
        <div>
          <Label>Nama</Label>
          <Input data-testid="profile-name" value={form.name} onChange={e => setForm({ ...form, name: e.target.value })} />
        </div>
        <div>
          <Label>Instagram Handle</Label>
          <Input data-testid="profile-ig" placeholder="@username" value={form.instagram_handle || ""} onChange={e => setForm({ ...form, instagram_handle: e.target.value })} />
        </div>
        <div>
          <Label>Bio</Label>
          <Textarea data-testid="profile-bio" value={form.bio || ""} onChange={e => setForm({ ...form, bio: e.target.value })} placeholder="Ceritakan tentang dirimu..." />
        </div>
        <div className="space-y-3 pt-2">
          <div className="rounded-lg border border-border bg-muted/50 p-4 text-muted-foreground">
            <label className="flex items-center gap-3 cursor-not-allowed">
              <input type="checkbox" data-testid="role-owner" checked={form.is_owner} disabled className="w-4 h-4 accent-gray-400" readOnly />
              <span className="text-sm">Saya pemilik restoran</span>
            </label>
            <p className="mt-2 text-xs">
              Akses restoran harus disetujui admin sebelum kamu bisa membuka dan mengelola halaman restoran.
            </p>
            {!form.is_owner && (
              <Button
                type="button"
                variant="outline"
                disabled={ownerPending || requestingOwner}
                onClick={requestOwnerAccess}
                className="mt-3 rounded-full"
                data-testid="request-owner-access"
              >
                {ownerPending ? "Request sedang diproses" : requestingOwner ? "Mengirim..." : "Request buka halaman restoran"}
              </Button>
            )}
          </div>
          <label className="flex items-center gap-3 cursor-pointer">
            <input type="checkbox" data-testid="role-influencer" checked={form.is_influencer} onChange={e => setForm({ ...form, is_influencer: e.target.checked })} className="w-4 h-4" />
            <span className="text-sm">Saya influencer kuliner</span>
          </label>
        </div>
        <Button type="submit" className="rounded-full" data-testid="save-profile-btn">Simpan</Button>
      </form>
    </div>
  );
};

export default Profile;
